import { MaskLines, FadeIn } from "@/components/Reveal";

export const PageHeader = ({ eyebrow, title, lines, subtitle, image }) => (
  <section className="relative min-h-[62vh] flex items-end overflow-hidden grain">
    <div className="absolute inset-0">
      <img src={image} alt={title} className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-black/40" />
    </div>
    <div className="container-olime relative z-10 pb-16 lg:pb-24 pt-40 text-white">
      <FadeIn><span className="eyebrow text-white/70">{eyebrow}</span></FadeIn>
      <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] mt-4 tracking-tight !text-white">
        <MaskLines lines={lines || [title]} base={0.15} />
      </h1>
      {subtitle && <FadeIn delay={0.5}><p className="mt-6 max-w-xl text-white/80 text-base md:text-lg font-light">{subtitle}</p></FadeIn>}
    </div>
  </section>
);
